export const SET_LOADING = 'SET_LOADING'
export const SET_PROFILE = 'SET_PROFILE'
export const SET_BANNER_LIST = 'SET_BANNER_LIST'
